/**
 * Ein Angebot/Abo gilt als digital, wenn es entweder ePaper oder PaidContent ist – beides ohne Postversand.
 * Nimmt bewusst nur die offerType/subscriptionType-Form entgegen, da Offer.offerType und
 * Subscription.subscriptionType dieselbe Struktur teilen.
 */
export function isDigital(offerType: { ePaper: boolean, paidContent: boolean }): boolean {
  return !!offerType?.ePaper || !!offerType?.paidContent;
}
